const API_ENDPOINT = 'TitleOfNames'

export const API_TITLE_OF_NAMES = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: { id: TitleOfName['id'] }) =>  `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: { id: TitleOfName['id'] }) => `${API_ENDPOINT}/Delete/${data.id}`,
}

export class TitleOfName {
  id!: string
  title: string = ''
  isActive: boolean = true
  rank: number = 0
}
